/**
 * Clear Filters Functionality
 * 
 * Handles clearing all filter parameters from the URL and triggering a facet update
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const clearButtonWrapper = document.getElementById('clear-filters-button');
    
    if (!clearButtonWrapper) {
      return;
    }

    // Find the actual button element inside the wrapper
    const clearButton = clearButtonWrapper.querySelector('button');
    
    if (!clearButton) {
      return;
    }

    clearButton.addEventListener('click', handleClearFilters);
  }

  function handleClearFilters(event) {
    event.preventDefault();

    // Get the current URL
    const currentUrl = new URL(window.location.href);
    
    // Get the base path without any query parameters
    const cleanUrl = new URL(currentUrl.origin + currentUrl.pathname);
    
    // Preserve the sort_by parameter if it exists
    const sortBy = currentUrl.searchParams.get('sort_by');
    if (sortBy) {
      cleanUrl.searchParams.set('sort_by', sortBy);
    }

    // Get the section ID from the page
    const shopifySection = document.querySelector('.shopify-section--main-collection');
    if (shopifySection) {
      const sectionId = shopifySection.id.replace('shopify-section-', '');
      cleanUrl.searchParams.set('section_id', sectionId);
    }

    // Dispatch the facet:update event (same as Apply filters)
    document.dispatchEvent(new CustomEvent('facet:update', {
      bubbles: true,
      detail: {
        url: cleanUrl
      }
    }));

    // Close the drawer
    const drawer = document.getElementById('facets-drawer');
    if (drawer && drawer.hide) {
      drawer.hide();
    }
  }

  // Re-initialize when filters are updated (for drawer/ajax updates)
  document.addEventListener('facet:update', function() {
    setTimeout(function() {
      init();
    }, 100); // Small delay to ensure DOM is updated
  });

})();

